import React, { useState, useEffect } from 'react';
import './Gallery.css';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

const imageUrls = [
  'https://d2h00ixa8oo5wc.cloudfront.net/photo1.webp',
  'https://d2h00ixa8oo5wc.cloudfront.net/photo2.webp',
  'https://d2h00ixa8oo5wc.cloudfront.net/photo3.webp',
  'https://d2h00ixa8oo5wc.cloudfront.net/photo4.webp',
  'https://d2h00ixa8oo5wc.cloudfront.net/photo6.webp',
  'https://d2h00ixa8oo5wc.cloudfront.net/photo7.webp',
  'https://d2h00ixa8oo5wc.cloudfront.net/photo5.webp',
  'https://d2h00ixa8oo5wc.cloudfront.net/photo8.webp',
  'https://d2h00ixa8oo5wc.cloudfront.net/photo10.webp',
  'https://d2h00ixa8oo5wc.cloudfront.net/photo12.webp'
];

const Gallery = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [images, setImages] = useState([]);

  useEffect(() => {
    const checkImages = async () => {
      const validImages = [];
      for (const url of imageUrls) {
        try {
          const response = await fetch(url);
          if (response.ok) {
            validImages.push(url);
          } else {
            console.error(`Failed to load image: ${url}`);
          }
        } catch (error) {
          console.error(`Error fetching image: ${url}`, error);
        }
      }
      setImages(validImages);
    };

    checkImages();
  }, []);

  const preloadImage = (src, callback) => {
    const img = new Image();
    img.src = src;
    img.onload = callback;
    img.onerror = () => {
      console.error(`Failed to load image: ${src}`);
    };
  };

  const handleImageClick = (index) => {
    setIsOpen(true);
    setPhotoIndex(index);
    preloadImage(images[index], () => setImageLoaded(true));
  };

  const closeLightbox = () => {
    setIsOpen(false);
    setImageLoaded(false);
  };

  return (
    <section id="gallery">
      <div className="gallery-container">
        <h2>Galeria</h2>
        <div className="gallery-grid">
          {images.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`Hotel View ${index + 1}`}
              className="gallery-image"
              loading="lazy"
              onClick={() => handleImageClick(index)}
              onError={(e) => {
                e.target.src = 'https://via.placeholder.com/150'; // Fallback image
                console.error(`Failed to load image: ${image}`);
              }}
            />
          ))}
        </div>
      </div>
      {isOpen && (
        <Lightbox
          mainSrc={images[photoIndex]}
          nextSrc={images[(photoIndex + 1) % images.length]}
          prevSrc={images[(photoIndex + images.length - 1) % images.length]}
          onCloseRequest={closeLightbox}
          onMovePrevRequest={() => {
            const newIndex = (photoIndex + images.length - 1) % images.length;
            preloadImage(images[newIndex], () => {
              setPhotoIndex(newIndex);
              setImageLoaded(true);
            });
          }}
          onMoveNextRequest={() => {
            const newIndex = (photoIndex + 1) % images.length;
            preloadImage(images[newIndex], () => {
              setPhotoIndex(newIndex);
              setImageLoaded(true);
            });
          }}
        />
      )}
    </section>
  );
};

export default Gallery;